<template>
<div class="hello">
    <Menu></Menu>
    <div class="class">
        <div class="floating-write">
            <a :href="'noticeadd?classid='+classid"><img src="../assets/img/write.png" /></a>
        </div>
        <!-- <div class="page-top-wrap"> -->
        <div class="top wrap clear">
            <!-- <div class="board"></div> -->
            <h2 class="bold  float-left">클래스 게시판</h2><br>
            <p class="mt-10 bold">{{classinfo.classname}}</p>
            <p class="font-14">수업 문의, 학습자료, 과제 제출을 할 수 있는 게시판입니다.</p>
            <div class="pt-10">
                <select v-model="category" @change="doSearch()">
                    <option value="">카테고리 전체</option>
                    <option value="D">Daily Feedback</option>
                    <option value="E">학습자료</option>
                    <option value="N">공지</option>
                    <option value="Q">문의</option>
                    <option value="H">과제제출</option>
                    <option value="T">기타</option>
                </select>
                <!-- <select class="ml-10" v-model="sub_category" @change="doSearch()">
                    <option value="">전체</option>
                    <option value="my">내가 쓴글</option>
                </select> -->
                <label class="ml-20 font-14"><input type="checkbox" v-model="is_sub_category" @change="CategoryChange()"/>&nbsp;내가 쓴글</label>
            </div>
        </div>
        <!-- </div> -->

        <div class="page-top-wrap-notice">
            <!-- <div class="none-notice">
                <p>등록된 글이 없습니다.</p>
            </div> -->
            <div class="notice-wrap">
                <ul>
                    <li v-for="(item,index) in datalist" :key="index" @click="goView(item)">
                        <div>
                            <span class="writer">{{item.kname}}</span>
                            <span class="gubun btn-point ml-10" v-if="item.gubun == 'HQ'">매니저</span>
                            <span class="gubun btn-point ml-10" v-if="item.gubun == 'TUTOR'">강사님</span>
                            <span class="line ml-10 mr-10">|</span>
                            <span class="comment"><img src="../assets/img/comment_icon.png" />&nbsp;{{item.cmtcnt}}</span>
                            <span class="createdate">{{item.createdate}}</span>
                        </div>
                        <h1>[{{item.category_text}}] {{item.title}}</h1>
                    </li>
                    <li v-if="datalist.length != total">
                        <p @click="more_page()"><img src="../assets/img/down-arrow.png" class="mr-10" />더보기</p>
                    </li>
                </ul>
            </div>
            <div class="btn">
                <button @click="goAdd()">글쓰기</button>
            </div>
        </div>

    </div>

    <!-- 푸터 -->
    <div class="footer clear">
        Copyright© <span class="bold">CARROT</span> Global Inc. All rights reserved.<br>
    </div>
</div>
</template>

<script>
import Menu from '../components/inc_menu.vue'
export default {
    name: 'NoticeList',
    components: {
        Menu
    },
    props: {
        msg: String
    },
    data: () => ({
        classid: "",
        is_check: 0,
        page: 1,
        sdate: "",
        edate: "",
        sfield: "",
        stext: "",
        info: {},
        datalist: [],
        total: 0,
        winfo: {
            b_idx: 0,
            wcontents: "",
            wupfilename: ""
        },
        wcontents: "",
        vinfo: {},
        cmtList: [],
        cmtTotal: 0,
        ccontents: "",
        size: 50,
        category: "",
        sub_category: "",
        is_sub_category: false,
        classinfo: {},
    }),
    created() {
        if(location.hostname == "stagest.carrotenglish.net"){
            this.$store.commit('changeHost', "https://stagestapi.carrotenglish.net");
        }else if(location.hostname == "st.carrotenglish.net"){
            this.$store.commit('changeHost', "https://stapi.carrotenglish.net");
        }else if(location.hostname == "student.carrotenglish.net"){
            this.$store.commit('changeHost', "https://stapi.carrotenglish.net");
        }else if(location.hostname == "m.carrotenglish.net"){
            this.$store.commit('changeHost', "https://stapi.carrotenglish.net");
        }else if(location.href.includes("how")){
            if(location.href.includes("stage")){
                this.$store.commit('changeHost', "https://stagestapi.carrotenglish.net");
            }else{
                this.$store.commit('changeHost', "https://stapi.carrotenglish.net");
            }
        }else{
            this.$store.commit('changeHost', "https://stapi.carrotenglish.net");
        }
        this.$store.commit("loginCheck");
    },
    mounted() {
        //    this.doc_del_rendar();
        this.classid = this.$route.query.classid;
        this.doSearch();
        this.getClassInfo();
    },
    methods: {
        CategoryChange:function(){
            if(this.is_sub_category == false){
                this.sub_category = "";
            }else{
                this.sub_category = "my";
            }
            this.doSearch();
        },
        goAdd:function(){
            location.href="noticeadd?classid="+this.classid;
        },
        getClassInfo: function () {
            var me = this;
            var params = {
                uidx: localStorage.getItem("uidx"),
            };
            this.axios.get(this.$store.state.host + '/rest/mobile/classinfo_new/' + me.classid, {
                params: params
            }).then(function (res) {
                if (res.data.err == 0) {
                    me.classinfo = res.data;
                    console.log(me.classinfo);
                } else {
                    alert(res.data.err_msg);
                }
                me.is_loader = false;
            });
        },
        goView: function (item) {
            // console.log(item);
            location.href = "/noticeview?b_idx=" + item.b_idx + "&bcode=" + item.bcode + "&classid=" + this.classid;

        },
        more_page: function () {
            this.size = this.size + 50;
            // console.log(this.size);
            this.doSearch();
        },
        doSearch: function () {
            console.log("search info");
            var params = {
                page: this.page,
                classid: this.classid,
                sdate: this.sdate,
                edate: this.edate,
                sfield: this.sfield,
                stext: this.stext,
                tmr: Date.now(),
                uidx: localStorage.getItem("uidx"),
                size: this.size,
                category: this.category,
                sub_category: this.sub_category
            };
            var me = this;
            this.axios.get(this.$store.state.host + "/rest/mobile/classboard_new", {
                params: params
            }).then(function (res) {
                if (res.data.err == 0) {
                    me.info = res.data;
                    me.datalist = me.info.list;
                    me.total = res.data.total;
                    console.log(me.datalist);
                    // me.chkViewForm(12216);
                } else {
                    alert(res.data.err_msg);
                }
                me.is_loader = false;
            });
        }
    }
    //   
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+KR:wght@400;700&display=swap');

$point-color: #53CAFF;
$purple: #6974FF;
$gray: #B7B7B7;
$border-color: #E9E9E9;
$back-gray: #F5F5F5;

// 결석
$absent: #FF4068;
// 출석
$attend: #53CAFF;
// 휴강
$cancel: #FFB055;
// 예정
$scheduled: #E1E1E1;
// 공결
$reasons: #2FEECD;

.btn {
    text-align: right;
    padding-top: 20px;
    margin: 0 auto;
    display: block;
    button {
        background: #53CAFF 0% 0% no-repeat padding-box;
        border-radius: 3px;
        opacity: 1;
        font-size: 14px;
        letter-spacing: 0px;
        color: #FFFFFF;
        opacity: 1;
        padding: 5px 10px;
        border: none;
    }
}

.class {
    width: 1200px;
    margin: 0 auto;
    padding-bottom: 60px;

    .floating-write {
        position: fixed;
        right: 0;
        cursor: pointer;
        display: none;
        bottom: 0;
    }

    // .page-top-wrap {
    //     width: 100%;
    //     border-bottom: 10px solid #F5F5F5;

    .top {
        position: relative;
        // padding-right: 20px;
        padding-bottom: 17px;
        padding-top: 70px;
        background: url("../assets/img/top-bg.png") no-repeat right -80px;
        background-size: 300px;
        position: relative;

        border-bottom: 10px solid #f5f5f5;;

        .my-reason {
            position: absolute;
            right: 0;
            bottom: 15%;
        }

        p {
            font-size: 16px;
            letter-spacing: 0px;
            color: #000000;
            opacity: 1;
            margin-top: 10px;
        }

        div {
            select {
                border: 1px solid var(--unnamed-color-53caff);
                background: #FFFFFF 0% 0% no-repeat padding-box;
                border: 1px solid black;
                border-radius: 4px;
                opacity: 1;
                color: black;
                ;
            }
        }

        .board{
            position: absolute;
            width: 100%;
            height: 10px;
            background: #f5f5f5;;
            left: 0;
        }
    }

    .wrap {
        width: 90%;
        max-width: 700px;
    }

    // }

    .page-top {
        border-bottom: 1px solid #E9E9E9;

        .review-top {

            div {
                background: #F5F5F5 0% 0% no-repeat padding-box;
                border: 1px solid #E9E9E9;
                border-radius: 10px;
                opacity: 1;
                width: 95%;
                margin: 0 auto;
                box-sizing: border-box;
                padding-top: 19px;
                padding-bottom: 19px;

                p {
                    float: left;
                    text-align: center;

                    &:first-child {
                        font-size: 14px;
                        letter-spacing: 0px;
                        color: #B7B7B7;
                        opacity: 1;
                    }

                    &:last-child {
                        font-size: 14px;
                        letter-spacing: 0px;
                        color: #000000;
                        opacity: 1;
                    }
                }
            }
        }
    }

    .page-top-wrap-notice {
        width: 90%;
        margin: 0 auto;
        max-width: 700px;

        .none-notice {
            display: table;
            min-height: 300px;
            width: 100%;

            p {
                display: table-cell;
                vertical-align: middle;
                text-align: center;
                color: var(--unnamed-color-b7b7b7);
                text-align: center;
                font-size: 16px;
                font-weight: bold;
                letter-spacing: 0px;
                color: #B7B7B7;
                opacity: 1;
            }
        }

        .notice-wrap {
            ul {
                li {
                    width: 100%;
                    padding: 22px;
                    border-bottom: 1px dashed #E9E9E9;
                    cursor: pointer;

                    div {
                        .writer {
                            font-size: 14px;
                            letter-spacing: 0px;
                            color: #B7B7B7;
                            opacity: 1;
                        }

                        .line {
                            color: #B7B7B7;
                        }

                        .comment {
                            color: #B7B7B7;
                            font-size: 12px;
                            letter-spacing: 0px;
                            color: #B7B7B7;
                            opacity: 1;
                            img{
                                width: 15px;
                            }
                        }

                        .createdate {
                            float: right;
                            font-size: 11px;
                            letter-spacing: 0px;
                            color: #B7B7B7;
                            opacity: 1;
                        }
                    }

                    h1 {
                        text-align: left;
                        font-size: 16px;
                        letter-spacing: 0px;
                        color: #000000;
                        opacity: 1;
                        font-weight: bold;
                        margin-top: 5px;
                    }
                    &:first-child{
                    border-top: 1px dashed #E9E9E9;
                    }
                    &:last-child {
                        // border-bottom: 0px;

                        p {
                            text-align: center;
                            font-size: 14px;
                            letter-spacing: 0px;
                            color: #B7B7B7;
                            opacity: 1;
                        }
                    }
                }
            }
        }
    }
}

.btn-base-white {
    padding: 5px;
}

.footer {
    position: static;
}

@media only screen and (max-width: 414px) {
    .btn{
        display: none;
    }
    .class {
        width: 100%;
    }

    .class {
        .floating-write{
            display: block;
        }
        .top {
            background: url("../assets/img/top-bg.png") no-repeat 160px -80px;
            background-size: 300px;
                // border-top: 10px solid #f5f5f5;
            &.wrap {
                width: 100%;
                padding-left: 5%;
                max-width: none;
            }
        }

        .page-top-wrap-notice {
            width: 100%;
        }

        .page-top-wrap {
            .wrap {
                width: 100%;
                max-width: none;
            }
        }
    }
}
</style>
